import React from 'react';
import AuthLayout from '../common/AuthLayout';
import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPasswordPage = ({ onNavigate }) => {
  const handleBackToHome = () => {
    onNavigate('main');
  };

  return (
    <AuthLayout
      title="Forgot your password?"
      subtitle="No worries, we'll send you reset instructions."
    >
      <div className="mb-4">
        <button
          onClick={handleBackToHome}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
        >
          ← Back to Home
        </button>
      </div>
      <ForgotPasswordForm onNavigate={onNavigate} />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
